import { Action } from '@ngrx/store';

export const SET_VDBUILDTYPE = 'SET_VDBUILDTYPE';
export const SET_VDVISAID = 'SET_VDVISAID';
export const SET_VDVISAINFO = 'SET_VDVISAINFO';

export class SetVDBuildType implements Action {
  readonly type = SET_VDBUILDTYPE;

  constructor(public payload: any) { }
}

export class SetVDVisaId implements Action {
  readonly type = SET_VDVISAID;

  constructor(public payload: any) { }
}

export class SetVDVisaInfo implements Action {
  readonly type = SET_VDVISAINFO;

  constructor(public payload: any) { }
}

export type VDActions = SetVDBuildType | SetVDVisaId | SetVDVisaInfo;
